@if(invoice != null){
<div class="flex flex-wrap max-w-ultrawide gap-2 justify-between mobile:justify-center">
    <div class="bg-secondary-100 rounded-[16px] p-4 flex-[1] min-w-[200px] h-auto min-h-[80px]">
        <p class="text-sm">{{ 'invoice.period' | transloco }}</p>
        <p class="text-2xl mobile:text-sm font-bold">{{ invoice.for_period ?? '' | isoPeriod }}</p>
    </div>

    <div class="bg-secondary-100 rounded-[16px] p-4 flex-[1] min-w-[200px] h-auto min-h-[80px]">
        <p class="text-sm">{{ 'invoice.total_consumption' | transloco }}:</p>
        <p class="text-2xl mobile:text-sm font-bold">{{ invoice.total_consumption | number:'1.2-2' }} {{ 'shared.kwh' |
            transloco }}
        </p>
    </div>

    <div class="bg-secondary-100 rounded-[16px] p-4 flex-[1] min-w-[200px] h-auto min-h-[80px]">
        <p class="text-sm">{{ 'invoice.total_taxable_amount' | transloco }}:</p>
        <p class="text-2xl mobile:text-sm font-bold">{{ invoice.invoice_amount_net_actual | number:'1.2-2' }}€</p>
    </div>

    <div class="bg-secondary-100 rounded-[16px] p-4 flex-[1] min-w-[200px] h-auto min-h-[80px]">
        <p class="text-sm">{{ 'shared.pages.invoice' | transloco }}</p>
        <div class="flex justify-between items-center">
            <p class="text-2xl mobile:text-sm font-bold" *ngIf="getInvoiceStatus(invoice)">{{ 'invoice.check' |
                transloco }} </p>
            <p class="text-2xl mobile:text-sm font-bold" *ngIf="!getInvoiceStatus(invoice)">
                <app-invoice-status-text [invoiceStatus]="invoice.status"
                    [visibilityStatus]="invoice.visibility_status"></app-invoice-status-text>
            </p>
            <app-invoice-status [statusEnum]="invoice.status!" [statusOkColor]="statusOkColor"></app-invoice-status>
        </div>

    </div>
</div>

@if(invoice.visibility_status === VisibilityStatus.UNDER_ADMIN_REVIEW && 
    invoice.status !== InvoiceStatus.DONE && 
    invoice.status !== InvoiceStatus.VALID && 
    invoice.status !== InvoiceStatus.IN_DISPUTED)
{
<div class="flex items-start gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4 mt-5">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-500 mt-1" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M12 20c4.418 0 8-3.582 
               8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z" />
    </svg>

    <div>
        <p class="text-blue-900 font-medium">{{ 'invoice.under_admin_review_title' | transloco }}</p>
        <p class="text-blue-800 text-sm mt-1">{{ 'invoice.under_admin_review_message' | transloco }}</p>
    </div>
</div>}
@else if(summedPOD){
<div
    class="flex w-full max-w-ultrawide desktop:flex-wrap mobile:flex-col gap-2 mobile:gap-4 mobile:justify-center mt-6">
    <div class="border-[1px] border-border rounded-[16px] h-[300px] min-w-[300px] desktop:flex-[1]">
        <app-energy-by-tariff-period [consumption]="consumption" [kwhCosts]="kwhCosts"
            [labels]="labels"></app-energy-by-tariff-period>
    </div>
    <div class="border-[1px] border-border rounded-[16px] h-[300px] min-w-[300px] desktop:flex-[1]">
        <app-invoice-energy-doughnut-chart [chartData]="chartData"
            [kwhNumber]="kwhNumber"></app-invoice-energy-doughnut-chart>
    </div>
    <div class="rounded-[16px] h-[300px] min-w-[300px] desktop:flex-[1] flex flex-col gap-1 justify-between">
        <div class="flex flex-col gap-1">
            <div class="flex gap-2">
                <app-invoice-status [status]="invoice.is_consumption_ok"
                    [statusOkColor]="statusOkColor"></app-invoice-status>
                <p class="text-neutral-1500">{{ 'invoice.check_consumption' | transloco }}</p>
            </div>

            <div class="h-[1px] bg-border w-full"></div>

            <div class="flex gap-2">
                <app-invoice-status [status]="summedPOD.is_tms_charges_ok"
                    [statusOkColor]="statusOkColor"></app-invoice-status>
                <p class="text-neutral-1500">{{ 'invoice.transportation' | transloco }}</p>
            </div>

            <div class="h-[1px] bg-border w-full"></div>

            <div class="flex gap-2">
                <app-invoice-status [status]="invoice.is_taxes_ok" [statusOkColor]="statusOkColor"></app-invoice-status>
                <p class="text-neutral-1500">{{ 'invoice.taxes' | transloco }}</p>
            </div>

            <div class="h-[1px] bg-border w-full"></div>

            <div class="flex gap-2">
                <app-invoice-status [status]="invoice.is_invoice_amount_ok"
                    [statusOkColor]="statusOkColor"></app-invoice-status>
                <p class="text-neutral-1500">{{ 'invoice.total_invoice_amount' | transloco }}</p>
            </div>

            <div class="h-[1px] bg-border w-full"></div>
        </div>
        <div class="flex gap-2 justify-between mobile:justify-center desktop:flex-wrap mobile:flex-col">
            <div class="desktop:flex-[1] h-[50px] min-w-[200px] max-w-[1000px]">
                <app-custom-button buttonText="{{ 'invoice.download_report' | transloco }}"
                    backgroundColor="bg-secondary" textColor="text-white" borderColor="border:bg-secondary"
                    (buttonClick)="downloadDisputeReport()"
                    hoverBackgroundColor="hover:bg-secondary-1200"></app-custom-button>
            </div>
            <div class="desktop:flex-[1] h-[50px] min-w-[200px] max-w-[1000px]">
                <app-custom-button *ngIf="!getInvoiceStatus(invoice) && invoice.status !== InvoiceStatus.DONE" buttonText="{{ 'shared.talk_to_expert' | transloco }}"
                    backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                    hoverBackgroundColor="hover:bg-primary-1200" (buttonClick)="disputeReport()" />
            </div>
        </div>


    </div>
</div>
}
}